import type { BooleanInventoryListingConfig } from "@dealer-center/ddc-pages-inventory-config-interface";
import type { baseInputs } from "./base";

type booleanInputsListFlat = Record<booleanListType, booleanInputs>;

export interface booleanInputs extends baseInputs {
  type: "checkbox";
  default: boolean;
}
export type booleanListType = keyof BooleanInventoryListingConfig;

export const booleanInputsListFlat: booleanInputsListFlat = {
  imaging: {
    type: "checkbox",
    dataIndex: "imaging",
    label: "Imaging",
    default: true
  },
  showTotalCount: {
    label: "Show Total Count",
    type: "checkbox",
    dataIndex: "showTotalCount",
    default: true
  },
  makeOffer: {
    type: "checkbox",
    dataIndex: "makeOffer",
    label: "Make Offer",
    default: false
  },
  toolTip: {
    type: "checkbox",
    dataIndex: "toolTip",
    label: "Tool Tip",
    default: true
  },
  paging: {
    type: "checkbox",
    dataIndex: "paging",
    label: "Paging",
    default: true
  },
  compare: {
    type: "checkbox",
    dataIndex: "compare",
    label: "Compare",
    default: true
  },
  epricer: {
    type: "checkbox",
    dataIndex: "epricer",
    label: "E-Pricer",
    default: false
  },
  featured: {
    type: "checkbox",
    dataIndex: "featured",
    label: "Featured",
    default: false
  },
  smartBrowsing: {
    type: "checkbox",
    dataIndex: "smartBrowsing",
    label: "Smart Browsing",
    default: true
  },
  camera: {
    type: "checkbox",
    dataIndex: "camera",
    label: "Camera",
    default: true
  },
  priority: {
    type: "checkbox",
    dataIndex: "priority",
    label: "Priority",
    default: false
  },
  certified: {
    type: "checkbox",
    dataIndex: "certified",
    label: "Certified",
    default: false
  },
  excludeCertified: {
    type: "checkbox",
    dataIndex: "excludeCertified",
    label: "Exclude Certified",
    default: false
  },
  videoOnly: {
    type: "checkbox",
    dataIndex: "videoOnly",
    label: "Video Only",
    default: false
  },
  showCertifiedLogo: {
    type: "checkbox",
    dataIndex: "showCertifiedLogo",
    label: "Show Certified Logo",
    default: true
  },
  showCalc: {
    type: "checkbox",
    dataIndex: "showCalc",
    label: "Show Calc",
    default: true
  },
  carFaxOneOwnerOnly: {
    type: "checkbox",
    dataIndex: "carFaxOneOwnerOnly",
    label: "CarFax One Owner Only",
    default: false
  },
  sbShowCounts: {
    type: "checkbox",
    dataIndex: "sbShowCounts",
    label: "Show Counts",
    default: false
  },
  sbShowYear: {
    type: "checkbox",
    dataIndex: "sbShowYear",
    label: "Show Year",
    default: false
  },
  sbShowMake: {
    type: "checkbox",
    dataIndex: "sbShowMake",
    label: "Show Make",
    default: true
  },
  sbShowModel: {
    type: "checkbox",
    dataIndex: "sbShowModel",
    label: "Show Model",
    default: true
  },
  sbShowTrim: {
    type: "checkbox",
    dataIndex: "sbShowTrim",
    label: "Show Trim",
    default: false
  },
  sbShowBodyStyle: {
    type: "checkbox",
    dataIndex: "sbShowBodyStyle",
    label: "Show Body Style",
    default: true
  },
  sbShowEngine: {
    type: "checkbox",
    dataIndex: "sbShowEngine",
    label: "Show Engine",
    default: false
  },
  sbShowEngineSize: {
    type: "checkbox",
    dataIndex: "sbShowEngineSize",
    label: "Show Engine Size",
    default: false
  },
  sbShowMileage: {
    type: "checkbox",
    dataIndex: "sbShowMileage",
    label: "Show Mileage",
    default: false
  },
  sbShowPrice: {
    type: "checkbox",
    dataIndex: "sbShowPrice",
    label: "Show Price",
    default: false
  },
  sbShowFuel: {
    type: "checkbox",
    dataIndex: "sbShowFuel",
    label: "Show Fuel",
    default: false
  },
  sbShowCityMPG: {
    type: "checkbox",
    dataIndex: "sbShowCityMPG",
    label: "Show City MPG",
    default: false
  },
  sbShowHighwayMPG: {
    type: "checkbox",
    dataIndex: "sbShowHighwayMPG",
    label: "Show Highway MPG",
    default: false
  },
  sbShowAccount: {
    type: "checkbox",
    dataIndex: "sbShowAccount",
    label: "Show Account",
    default: false
  },
  sbShowCertified: {
    type: "checkbox",
    dataIndex: "sbShowCertified",
    label: "Show Certified",
    default: false
  },
  showStockNumberSearch: {
    type: "checkbox",
    dataIndex: "showStockNumberSearch",
    label: "Show Stock Number Search",
    default: false
  },
  sbShowClassification: {
    type: "checkbox",
    dataIndex: "sbShowClassification",
    label: "Show Classification",
    default: false
  },
  sbShowType: {
    type: "checkbox",
    dataIndex: "sbShowType",
    label: "Show Type",
    default: false
  },
  sbShowExtColor: {
    type: "checkbox",
    dataIndex: "sbShowExtColor",
    label: "Show Ext Color",
    default: false
  },
  sbShowIntColor: {
    type: "checkbox",
    dataIndex: "sbShowIntColor",
    label: "Show Int Color",
    default: false
  },
  sbShowTransmission: {
    type: "checkbox",
    dataIndex: "sbShowTransmission",
    label: "Show Transmission",
    default: false
  },
  showVideo: {
    type: "checkbox",
    dataIndex: "showVideo",
    label: "Show Video",
    default: true
  },
  exclusiveAccountId: {
    type: "checkbox",
    dataIndex: "exclusiveAccountId",
    label: "Exclusive Account Id",
    default: true
  }
};

export const isCheckBoxInput = (input: baseInputs): input is booleanInputs => {
  return input.type === "checkbox";
};
